import styled, { css, keyframes } from 'styled-components';

import YatAnimatedOutline from '@pkg/components/Sections/Profile/AnimatedOutline';
import { BORDER_STROKE_WIDTH } from '@pkg/components/Sections/Profile/AnimatedOutline/styles';
import YatNFT from '@pkg/components/Sections/Profile/NFT';

import { NFTPreviewButton } from '../NFTPreviewButton';
import { RemoveButton } from '../RemoveButton';

export const NFT_OUTLINE_OFFSET = 12 + BORDER_STROKE_WIDTH;

export const StyledYatRemoveButton = styled(RemoveButton)`
    opacity: 1 !important;
`;

export const StyledNFTPreviewButton = styled(NFTPreviewButton)`
    opacity: 1;
`;

export const GridItemNFTWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

interface ContentProps {
    $outlineOffset: number;
    $isEditing?: boolean;
}
export const ContentWrapper = styled.div<ContentProps>`
    position: relative;
    margin: ${({ $outlineOffset }) => $outlineOffset}px;

    ${({ $isEditing }) =>
        !$isEditing &&
        css`
            cursor: pointer;
        `}
`;

const SCALE_IN = keyframes`
    to {
        opacity: 1;
        transform: scale(1);
    }
`;

interface NFTProps {
    $wasPreviewed?: boolean;
    $previewing?: boolean;
}

export const StyledYatNFT = styled(YatNFT)<NFTProps>`
    z-index: 1;

    ${({ $wasPreviewed, $previewing }) =>
        $wasPreviewed &&
        css`
            opacity: 0;
            transform: scale(0);

            ${!$previewing &&
            css`
                animation: ${SCALE_IN} ${({ theme }) => theme.transitions.speeds.normal}s
                    ${({ theme }) => theme.transitions.speeds.fast}s ${({ theme }) => theme.transitions.easesCss.on}
                    forwards;
            `}
        `}
`;

export const StyledYatAnimatedOutline = styled(YatAnimatedOutline)`
    z-index: 1;
`;

interface InformationWrapperProps {
    $outlineOffset: number;
}

export const InformationWrapper = styled.div<InformationWrapperProps>`
    margin-top: ${({ $outlineOffset }) => $outlineOffset}px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    mask: linear-gradient(to left, transparent, black 30px);
`;
